import { showAllQuery } from "../../context/DataContext";

const normalizeQueryForComparison = (query: string | null): string => {
    if (!query || query === showAllQuery) {
        return "";
    }
    return query.trim();
};

/*
 * Returns a redirect URL only when the keyword query meaningfully changed.
 * Adding an empty ?query= param on first facet apply is not a real change.
 */
const shouldRedirectForQueryChange = (
    fullUrl: string,
    newQuery: string
): string | null => {
    if (!fullUrl) {
        return null;
    }

    try {
        const url = new URL(fullUrl);
        const normalizedCurrent = normalizeQueryForComparison(
            url.searchParams.get("query")
        );
        const normalizedNew = newQuery.trim();

        if (normalizedCurrent === normalizedNew) {
            return null;
        }

        url.searchParams.set("query", normalizedNew);
        return url.toString();
    } catch {
        return null;
    }
};

export default shouldRedirectForQueryChange;
